// Cachimarket — interacciones propias (prefijo cm-)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initHeroCarousel();
  initCifras();
  initFaq();
  initGaleriaProducto();
  initVariantesProducto();
});

/* ---------- Reveal on scroll ---------- */
function initReveal() {
  var els = document.querySelectorAll('.cm-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cm-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cm-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

/* ---------- Hero carousel ---------- */
function initHeroCarousel() {
  var root = document.querySelector('[data-cm-hero]');
  if (!root) return;
  var slides = root.querySelectorAll('.cm-hero__slide');
  var dots = root.querySelectorAll('.cm-hero__dot');
  if (slides.length < 2) return;
  var current = 0;
  var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
  var timer;

  function show(i) {
    slides.forEach(function (s, idx) { s.classList.toggle('cm-active', idx === i); });
    dots.forEach(function (d, idx) { d.classList.toggle('cm-active', idx === i); });
    current = i;
  }
  function next() { show((current + 1) % slides.length); }
  function reset() { clearInterval(timer); timer = setInterval(next, interval); }

  dots.forEach(function (dot, idx) {
    dot.addEventListener('click', function () { show(idx); reset(); });
  });

  show(0);
  reset();
}

/* ---------- Cifras animadas (count-up) ---------- */
function initCifras() {
  var nums = document.querySelectorAll('[data-cm-cifra]');
  if (!nums.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      animarCifra(entry.target);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.5 });
  nums.forEach(function (el) { io.observe(el); });
}
function animarCifra(el) {
  var target = parseFloat(el.getAttribute('data-cm-cifra')) || 0;
  var suffix = el.getAttribute('data-cm-suffix') || '';
  var duration = 1400;
  var start = null;
  function step(ts) {
    if (!start) start = ts;
    var progress = Math.min((ts - start) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var value = target * eased;
    el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

/* ---------- FAQ acordeón ---------- */
function initFaq() {
  var items = document.querySelectorAll('.cm-faq__item');
  items.forEach(function (item) {
    var btn = item.querySelector('.cm-faq__q');
    var panel = item.querySelector('.cm-faq__a');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('cm-open');
      items.forEach(function (i) {
        i.classList.remove('cm-open');
        var p = i.querySelector('.cm-faq__a');
        if (p) p.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('cm-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

/* ---------- Galería de producto ---------- */
function initGaleriaProducto() {
  var wrap = document.querySelector('[data-cm-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-cm-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-cm-mini]');
  if (!main || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      main.src = full;
      main.alt = alt;
      minis.forEach(function (m) { m.classList.remove('cm-active'); });
      mini.classList.add('cm-active');
    });
  });
}

/* ---------- Variantes de producto ---------- */
function initVariantesProducto() {
  var form = document.querySelector('[data-cm-producto-form]');
  if (!form) return;
  var variantsData = form.querySelector('[data-cm-variants-json]');
  if (!variantsData) return;
  var variants;
  try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

  var swatchGroups = form.querySelectorAll('[data-cm-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-cm-precio]');
  var precioTachadoEl = document.querySelector('[data-cm-precio-tachado]');
  var stockEl = document.querySelector('[data-cm-stock]');
  var addBtn = form.querySelector('[data-cm-add-btn]');

  function seleccionActual() {
    var sel = [];
    swatchGroups.forEach(function (group) {
      var active = group.querySelector('.cm-active');
      if (active) sel.push(active.getAttribute('data-value'));
    });
    return sel;
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }

  function actualizar() {
    var sel = seleccionActual();
    var match = variants.find(function (v) {
      return v.options.length === sel.length && v.options.every(function (val, i) { return val === sel[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = money(match.price);
    if (precioTachadoEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioTachadoEl.textContent = money(match.compare_at_price);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (stockEl) {
      if (match.available) {
        stockEl.textContent = stockEl.getAttribute('data-disponible') || 'En stock';
        stockEl.classList.remove('cm-agotado');
      } else {
        stockEl.textContent = stockEl.getAttribute('data-agotado') || 'Agotado';
        stockEl.classList.add('cm-agotado');
      }
    }
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available
        ? (addBtn.getAttribute('data-texto-disponible') || addBtn.textContent)
        : (addBtn.getAttribute('data-texto-agotado') || 'Agotado');
    }
  }

  swatchGroups.forEach(function (group) {
    group.querySelectorAll('[data-value]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        group.querySelectorAll('[data-value]').forEach(function (s) { s.classList.remove('cm-active'); });
        swatch.classList.add('cm-active');
        actualizar();
      });
    });
  });

  actualizar();
}
